import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Helmet } from "react-helmet";
import { bindActionCreators } from "redux";
import { iapCallUs, iapPageData, getEduCoursesContent, iapgetFaqs } from './action';
import ReactPlayer from "react-player";
import TinySlider from "tiny-slider-react";
import "tiny-slider/dist/tiny-slider.css";
import Input from "../../general/Input/index";
import "./style.scss";
import { formDataGenerator, getYoutubePosterImage, getLang } from "../../../../utils/common";
import SipCalculator from "./SipCalculator";
import GoalCalculator from "./GoalCalculator";
import ChildrenCalculator from "./ChildrenCalculator";
import RetirementCalculator from "./RetirementCalculator";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import Modal from "react-modal";
import PaginationComponent from "../../general/PaginationComponent";

const IAPPage = (props) => {
  const {
    iapCallUs,
    iapPageData,
    iapLanding,
    getEduCoursesContent,
    educationCources,
    iapgetFaqs,
    faqsiap,
    location
  } = props;

  const [infoNodeId, setInfoNodeId] = useState('');
  const [error, setError] = useState({});
  const [checked, setChecked] = useState(false);
  const [iapData, setIAPData] = useState();
  const [bannerData, setBannerData] = useState();
  const [metaData, setMetaData] = useState();
  const [activeIndexbanner, setActiveIndexBanner] = useState();
  const [eduCourses, seteduCourses] = useState();
  const [togglevalue, settogglevalue] = useState(false);
  const [toggleCal1, settoggleCal1] = useState('');
  const [toggleCal2, settoggleCal2] = useState('');
  const [defaultValue, setdefaultValue] = useState('');

  const [values, setValues] = useState({
    name: "",
    mobile: "",
    email: "",
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [faqsData, setfaqsData] = useState();

  const settings = {
    items: 1,
    swipeAngle: false,
    controls: false,
    mouseDrag: true,
    loop: false,
  };
  const getPaginatedData = (page) => {
    loadData(page);
  };
  useEffect(() => {
    const fetchData = async () => {
      await loadHandler();
      window.scrollTo(0, 0);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let nodeId = location.pathname.split('/');
      if (infoNodeId !== "" && infoNodeId !== nodeId[nodeId.length - 1]) {
        await iapPageData({}, nodeId[nodeId.length - 1]);
        setInfoNodeId(nodeId[nodeId.length - 1]);
      }
    };
    fetchData();
  }, [location]);

  const loadHandler = async () => {
    let nodeId = location.pathname.split('/');
    await iapPageData({}, nodeId[nodeId.length - 1]);
    setInfoNodeId(nodeId[nodeId.length - 1]);
  };


  const onChange = (name, value) => {
    setValues((currentValue) => ({
      ...currentValue,
      [name]: value,
    }));
    onBlur(name, value);
  };
  const onBlur = (name, value) => {
    if (value.length !== 0) {
      switch (name) {
        case "mobile":
          if (/^[1-9]{1}[0-9]{9}$/.test(value)) {
            setError((currentValue) => ({
              ...currentValue,
              [name]: "",
            }));
          } else {
            setError((currentValue) => ({
              ...currentValue,
              [name]: "Invalid Mobile Number!",
            }));
          }
          break;
        default:
          setError((currentValue) => ({
            ...currentValue,
          }));
      }
    } else {
      setError((currentValue) => ({
        ...currentValue,
        [name]: "",
      }));
      // setSubmitDisabled(true);
    }
  };
  const onSubmit = async () => {
    const utm_source = new URLSearchParams(window.location.search);
    const utmSources = utm_source.get("utm_source") || "";
    const utmMedium = utm_source.get("utm_medium") || "";
    const utmCampaign = utm_source.get("utm_campaign") || "";

    const formData = formDataGenerator({
      name: values.name,
      mobile: values.mobile,
      pageName: iapData && iapData.title ? iapData.title : '',
      utm_source: utmSources.toString(),
      utm_medium: utmMedium.toString(),
      utm_campaign: utmCampaign.toString(),
    });
    await iapCallUs(formData);
  };

  const initialPlayingState = bannerData && bannerData.map(() => false);
  const initialPlayingState2 = iapData && iapData.thingsToConsider && iapData.thingsToConsider.length > 0 && iapData.thingsToConsider.map(() => false);

  const [playing, setPlaying] = useState({ first: false, second: false, third: false });
  const [activeIndex, setActiveIndex] = useState(1);

  const handlePlay = (player, index = null) => {
    console.log("INDEX...", player, index)
    if (player === 'first') {
      const newThirdPlaying = initialPlayingState.map((_, idx) => idx === index);
      setPlaying({ first: newThirdPlaying, second: false, third: initialPlayingState2 });
    } else if (player === 'second') {
      setPlaying({ first: initialPlayingState, second: true, third: initialPlayingState2 });
    } else if (player === 'third') {
      setActiveIndex(index);
      const newThirdPlaying = initialPlayingState2.map((_, idx) => idx === index);
      setPlaying({ first: initialPlayingState, second: false, third: newThirdPlaying });
    }
  };

  const handlePause = (player, index = null) => {
    if (player === 'first') {
      const newThirdPlaying = playing.first.map((item, idx) => (idx === index ? false : item));
      setPlaying((prevState) => ({ ...prevState, first: newThirdPlaying }));
    } else if (player === 'second') {
      setPlaying((prevState) => ({ ...prevState, second: false }));
    } else if (player === 'third') {
      const newThirdPlaying = playing.third.map((item, idx) => (idx === index ? false : item));
      setPlaying((prevState) => ({ ...prevState, third: newThirdPlaying }));
    }
  };

  useEffect(() => {
    if (iapLanding && iapLanding.iappageDataLanding) {
      setIAPData(iapLanding.iappageDataLanding);
    }
    if (iapLanding && iapLanding.iappageDataLanding && iapLanding.iappageDataLanding.bannerAndVideo) {
      setBannerData(iapLanding.iappageDataLanding.bannerAndVideo);
    }
    if (iapLanding && iapLanding.iappageDataLanding && iapLanding.iappageDataLanding.meta) {
      setMetaData(iapLanding.iappageDataLanding.meta);
    }
    if (iapLanding && iapLanding.iappageDataLanding && iapLanding.iappageDataLanding.calcualtor && iapLanding.iappageDataLanding.calcualtor[0] && iapLanding.iappageDataLanding.calcualtor[0].value) {
      settoggleCal1(iapLanding.iappageDataLanding.calcualtor[0].value);
      setdefaultValue(iapLanding.iappageDataLanding.calcualtor[0].value);
    }
    if (iapLanding && iapLanding.iappageDataLanding && iapLanding.iappageDataLanding.calcualtor && iapLanding.iappageDataLanding.calcualtor[1] && iapLanding.iappageDataLanding.calcualtor[1].value) {
      settoggleCal2(iapLanding.iappageDataLanding.calcualtor[1].value);
    }
  }, [iapLanding])

  useEffect(() => {
    let lang = getLang();
    getEduCoursesContent(lang)
  }, []);

  useEffect(() => {
    const payload = {
      limit: limit ? limit : '',
      offset: 0,
    };
    const typeData = window.location.pathname.split("/")[2];
    iapgetFaqs(formDataGenerator(payload), typeData);
  }, []);

  useEffect(() => {
    if (educationCources && educationCources.courses) {
      seteduCourses(educationCources.courses);
    }
  }, [educationCources]);

  useEffect(() => {
    if (faqsiap && faqsiap.iapFAQsData) {
      setfaqsData(faqsiap && faqsiap.iapFAQsData)
    }
    if (faqsiap && faqsiap.iapFAQsData && faqsiap.iapFAQsData.total_count) {
      setTotalRecords(faqsiap.iapFAQsData.total_count);
    }
  }, [faqsiap]);

  const handlePlanChange = (e) => {
    settogglevalue(e.target.checked);
    // e.preventDefault();
    if (e.target.checked) {
      setdefaultValue(toggleCal2);
    }
    else {
      setdefaultValue(toggleCal1);
    }

  }
  //modal1
  const [modalshow, setModalShow] = useState(false);
  const modalhandleClose = () => {
    setModalShow(false);
  };
  const modalhandleShow = (item, index) => {
    setModalShow(true);
    setActiveIndexBanner(item.youtubeId ? item.youtubeId : '');
  };

  const [faqsSelected, setfaqsSelected] = useState(null);
  const faqstoggle = (index) => {
    if (faqsSelected === index) {
      return setfaqsSelected(null);
    }
    setfaqsSelected(index);
  };
  const loadData = (page) => {
    const offsetValue = limit * (page - 1);
    let params = {
      limit: limit,
      offset: limit * (page - 1),
    };
    const typeData = window.location.pathname.split("/")[2];
    iapgetFaqs(formDataGenerator(params), typeData);
  };

  return (
    <div className="wrapper">
      <div className="sip-iap-page">
        {metaData &&
          <Helmet>
            <title>{metaData.title ? metaData.title : ''}</title>
            <meta name="description" content={metaData.description ? metaData.description : ''} />
            <meta name="keywords" content={metaData.keywords ? metaData.keywords : ''} />
            <meta property="og:title" content={metaData.og_title ? metaData.og_title : ''} />
            <meta property="og:description" content={metaData.og_description ? metaData.og_description : ''} />
            <meta property="og:image" content={metaData.og_image ? metaData.og_image : ''} />
            <meta property="og:url" content={metaData.og_url ? metaData.og_url : ''} />
          </Helmet>
        }
        <section className="aboutHead">
          <div className="container">
            <div className="d-flex">
              <h1 className="me-auto sipdiv">
                <span className='first-word'>
                  {iapData && iapData.title && iapData.title.split(' ')[0]}
                </span>&nbsp;
                {iapData && iapData.title && iapData.title.split(' ').slice(1).join(' ')}
              </h1>
              <nav
                aria-label="breadcrumb"
                className="align-self-center breadCrumbCust d-md-inlin"
              >
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active breadcolor">
                    <a href="/learners-corner">Learners Corner</a>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </section>
        <div className="banner-section">
          {bannerData && bannerData.length > 0 && (
            <TinySlider settings={settings}>
              {bannerData.map((item, index) => (
                <div key={index}>
                  {item && item.banner && item.banner.image_url && (
                    <div className="image">
                      <img src={item && item.banner && item.banner.image_url} alt={item && item.banner && item.banner.alt_text} />
                    </div>
                  )}
                  {item && item.mobileBanner && item.mobileBanner.image_url && (
                    <div className="mobile-image">
                      <img src={item && item.mobileBanner && item.mobileBanner.image_url} alt={item && item.banner && item.banner.alt_text} />
                    </div>
                  )}
                  {item && item.youtubeId && item && item.youtubeThumbnail && item.youtubeThumbnail.image_url && (
                    <div className="video">
                      <div className="thumbnail" onClick={() => modalhandleShow(item, index)}>
                        <img src={item && item.youtubeThumbnail && item.youtubeThumbnail.image_url ? item.youtubeThumbnail.image_url : ''} className="sip-landing-video-player" alt={item && item.youtubeThumbnail && item.youtubeThumbnail.alt_text ? item.youtubeThumbnail.alt_text : ''} />
                        <svg height="20%" version="1.1" viewBox="0 0 68 48" width="20%" className="youtubeicon"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </TinySlider>
          )}
        </div>
        <div className="content-section">
          <div className="how-sip">
            <div className="container">
              {iapData && iapData.body ?
                <div className={iapData && iapData.youtubeId ? "sip-working" : ''}>
                  <div dangerouslySetInnerHTML={{ __html: iapData.body }} />
                </div>
                : ''}
              {iapData && iapData.youtubeId ?
                <div className="guide">
                  <ReactPlayer
                    url={"https://www.youtube.com/watch?v=" + iapData.youtubeId}
                    controls={true}
                    className="sip-landing-video-player"
                    playing={playing.second}
                    onPlay={() => handlePlay('second')}
                    onPause={() => handlePause('second')}
                  />
                </div>
                : ''}
            </div>
          </div>
          {iapData && iapData.benefits && iapData.benefits.length > 0 &&
            <div className="benifits-sip">
              <div className="container">
                <h3 className="benefittitle">
                  {iapData && iapData.benefitsOfText && iapData.benefitsOfText.split(' ').slice(0, -1).join(' ')}
                  <span className='last-word'>
                    {iapData && iapData.benefitsOfText && iapData.benefitsOfText.split(' ').slice(-1)}
                  </span>
                  {/* Benefits of <span className="red-sip">SIP</span> */}
                </h3>
                <div className="row">
                  {iapData && iapData.benefits &&
                    iapData.benefits.length > 0 &&
                    iapData.benefits.map((item, index) => {
                      return (
                        <div className="col-md-6">
                          <div className="points">
                            <img src={item.icon && item.icon.icon_url ? item.icon.icon_url : ''} className="benefitimg" alt={item.icon && item.icon.alt_text ? item.icon.alt_text : ''} />
                            <p>
                              {item.description ? item.description : ''}
                            </p>
                          </div>
                        </div>
                      )
                    })}
                </div>
                {iapData && iapData.buttonText ?
                  <a href="#callbackform">
                    <div className="callback">{iapData && iapData.buttonText}</div>
                  </a>
                  : ""}
              </div>
            </div>
          }
          <div>
            {toggleCal1 && toggleCal2 &&
              <div className="filtertoggleiap mt-3 me-3">
                <div className="form-check form-switch p-0 d-flex justify-content-end align-items-center">
                  <label className="form-check-label cursorp">
                    {toggleCal1}
                  </label>

                  <input
                    className="form-check-input colorSwitch cursorp"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault1"
                    defaultChecked="checked"
                    onClick={(e) => handlePlanChange(e)}
                    checked={togglevalue}
                  />
                  <label
                    className="form-check-label cursorp"
                    htmlFor="flexSwitchCheckDefault1"
                  >
                    {toggleCal2}
                  </label>
                </div>
              </div>}
            {defaultValue && defaultValue == 'SIP Calculator' &&
              <SipCalculator IAPdata={iapData} />
            }
            {defaultValue && defaultValue == `Childrens Calculator` &&
              <ChildrenCalculator childData={eduCourses} />
            }
            {defaultValue && defaultValue == `Goal SIP` &&
              <GoalCalculator IAPdata={iapData} />
            }
            {defaultValue && defaultValue == `Retirement Calculator` &&
              <RetirementCalculator />
            }
          </div>
          {/* {iapData && iapData.banner && iapData.banner.url ? 
          <div className="getstarted">
            <div className="container">
              <img src={iapData && iapData.banner && iapData.banner.url} alt={iapData && iapData.banner && iapData.banner.alt ? iapData.banner.alt : ''} className="img-fluid"/>
            </div>
          </div>
          :''} */}
          {iapData && iapData.thingsToConsider && iapData.thingsToConsider.length > 0 &&
            <div className="my-5 pb-5 container Thingsdiv">
              {iapData && iapData.videosHeading ?
                <p className="thingstitle">{iapData.videosHeading}</p>
                : ''}
              <CarouselProvider
                naturalSlideWidth={100}
                naturalSlideHeight={75}
                currentSlide={activeIndex}
                visibleSlides={1}
                totalSlides={iapData &&
                  iapData.thingsToConsider &&
                  iapData.thingsToConsider.length}
              >
                <Slider className="slick-slider ThingsToConsider">
                  {iapData &&
                    iapData.thingsToConsider &&
                    iapData.thingsToConsider.length > 0 &&
                    iapData.thingsToConsider.map((video, index) => {
                      const posterImage = getYoutubePosterImage(
                        video.youtubeId
                      );
                      return (
                        <Slide index={index}>
                          <div className="card item">
                            <ReactPlayer
                              url={
                                video.youtubeId
                                  ? `https://www.youtube.com/watch?v=${video.youtubeId}`
                                  : ""
                              }
                              playing={playing.third[index]}
                              onPlay={() => handlePlay('third', index)}
                              onPause={() => handlePause('third', index)}
                              controls="true"
                              className="videoplayer"
                            />
                          </div>
                        </Slide>
                      );
                    })}
                </Slider>
                <ButtonBack className="leftarrow">{`<`}</ButtonBack>
                <ButtonNext className="rightarrow">{`>`}</ButtonNext>
              </CarouselProvider>
            </div>
          }
          <div className="faqs my-5 pt-4 p-2">
            <div className="container">
              <div className="faqsacord">
                <p className="faqtitle">FAQs</p>
                {faqsData &&
                  faqsData.faqs &&
                  faqsData.faqs.length > 0 &&
                  faqsData.faqs.map((item, index) => {
                    return (
                      <div className="item">
                        <div className={faqsSelected === index ? "title color" : "title"} onClick={() => faqstoggle(index)}>
                          <div>
                            <h2>{item.title ? item.title : ''}</h2>
                          </div>
                          <div>
                            {faqsSelected === index ?
                              <img src="/images/New/faqminus.svg" />
                              :
                              <img src="/images/New/faqplus.svg" />
                            }
                          </div>
                        </div>
                        <div className={faqsSelected === index ? "content show" : "content"}>
                          {item.description && <div dangerouslySetInnerHTML={{ __html: item.description }} />}
                        </div>
                      </div>
                    )
                  })}
              </div>
              {totalRecords > 10 && (
                <div className="row my-4">
                  <div className="col-md-12">
                    <div className="paginate d-flex justify-content-center">
                      <PaginationComponent
                        totalRecords={totalRecords}
                        activePage={activePage}
                        setActivePage={setActivePage}
                        data={data}
                        limit={limit}
                        getPaginatedData={getPaginatedData}
                        itemsCountPerPage={limit}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

        </div>
        <div id="callbackform">
          <div className="form-section">
            <div className="container">
              <div className="form-wrapper">
                <img src="/images/call.jpg" alt="call.jpg" />
                <div className="mobile-image">
                  <img src="/images/call-mobile.png" alt="call-mobile.png" />
                  <p>Get a call back</p>
                </div>
                {iapLanding.iapCallUs.apiLoaded && iapLanding.iapCallUs.success ?
                  <div className="form success">
                    <h3>
                      Thank you. We will call you back!
                    </h3>
                  </div>
                  :
                  <div className="form">
                    <div className="inputs">
                      <Input
                        name="name"
                        value={values.name}
                        errorMessage={error.name}
                        placeHolder="Name"
                        onChange={onChange}
                        isAlpha
                      />
                      <Input
                        name="mobile"
                        value={values.mobile}
                        errorMessage={error.mobile}
                        placeHolder="Mobile"
                        onChange={onChange}
                        isNumeric
                      />
                    </div>
                    <div className="terms-conditions">
                      <div className="condition">
                        <input
                          type="checkbox"
                          name="t-c"
                          id="t-c"
                          defaultChecked={checked}
                          onChange={() => setChecked(!checked)}
                        />
                        <label className="form-check-label" htmlFor="t-c">
                          I hereby authorize HDFC Mutual Fund and/or its authorized
                          service provider(s) to contact me for more information on
                          mutual funds. This will override any NDNC registration made
                          by me. An Investor Education Initiative by HDFC Mutual Fund.
                        </label>
                      </div>
                      <button
                        type="submit"
                        className="submit-btn"
                        disabled={
                          !values.mobile ||
                          !values.name ||
                          error.mobile ||
                          !checked
                        }
                        onClick={onSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        {iapLanding &&
          iapLanding.iappageDataLanding &&
          iapLanding.iappageDataLanding.disclaimer ?
          <div className="disclaimer-footer">
            <div className="container disclaimer">
              <div dangerouslySetInnerHTML={{ __html: iapLanding.iappageDataLanding.disclaimer }} /></div>
          </div> : ''}
      </div>
      <Modal
        isOpen={modalshow}
        onRequestClose={modalhandleClose}
        contentLabel="youtube modal"
        className="youtubemodal"
      >
        <div className="closebtn cursorp" onClick={modalhandleClose}>
          <svg width="44" height="48" viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.9998 43.6982C32.0832 43.6982 40.3332 34.9527 40.3332 24.2638C40.3332 13.5749 32.0832 4.82947 21.9998 4.82947C11.9165 4.82947 3.6665 13.5749 3.6665 24.2638C3.6665 34.9527 11.9165 43.6982 21.9998 43.6982Z" fill="#F6F6F6" />
            <path d="M16.8115 29.7638L27.1882 18.7639" stroke="#444444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M27.1882 29.7638L16.8115 18.7639" stroke="#444444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        {bannerData &&
          bannerData.length > 0 &&
          bannerData.map((item, index) => {
            if (item.youtubeId && item.youtubeId === activeIndexbanner) {
              return (
                <>
                  {item.youtubeId &&
                    <ReactPlayer
                      url={"https://www.youtube.com/watch?v=" + item.youtubeId}
                      controls={true}
                      className="youtube-modal-video-player"
                      playing={playing.first[index]}
                      onPlay={() => handlePlay('first', index)}
                      onPause={() => handlePause('first', index)}
                    />
                  }
                </>
              )
            }
          })}
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  iapLanding: state.iappage,
  educationCources: state.iappage,
  faqsiap: state.iappage,
});

const mapDispatchToProps = (dispatch) => ({
  iapCallUs: bindActionCreators(iapCallUs, dispatch),
  iapPageData: bindActionCreators(iapPageData, dispatch),
  getEduCoursesContent: bindActionCreators(getEduCoursesContent, dispatch),
  iapgetFaqs: bindActionCreators(iapgetFaqs, dispatch),
});

const IAPLandingContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(IAPPage);

export default withRouter(IAPLandingContainer);
